export const IS_DEBUG = false; //正式｜｜测试   false//正式环境     true 测试环境
export const API_VERSION = '1.0.0';//api版本号
